import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['track', 'progress', 'current', 'prevBtn', 'nextBtn']

  connect() {
    this.currentIndex = 0
    this.totalSlides = 8
    this.autoplayInterval = null

    this.updateUI()
    this.startAutoplay()

    // Pause autoplay on hover
    this.element.addEventListener('mouseenter', () => this.stopAutoplay())
    this.element.addEventListener('mouseleave', () => this.startAutoplay())
  }

  disconnect() {
    this.stopAutoplay()
  }

  next() {
    if (this.currentIndex < this.totalSlides - 1) {
      this.currentIndex += 1
      this.updateUI()
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex -= 1
      this.updateUI()
    }
  }

  goTo(index) {
    if (index >= 0 && index < this.totalSlides) {
      this.currentIndex = index
      this.updateUI()
    }
  }

  updateUI() {
    // Update track position
    if (this.hasTrackTarget) {
      this.trackTarget.style.transform = `translateX(-${this.currentIndex * 100}%)`
    }

    // Update progress indicators
    this.progressTargets.forEach((segment, index) => {
      if (index <= this.currentIndex) {
        segment.classList.add('active')
      } else {
        segment.classList.remove('active')
      }
    })

    // Update current display
    if (this.hasCurrentTarget) {
      this.currentTarget.textContent = String(this.currentIndex + 1).padStart(2, '0')
    }

    // Update button states
    if (this.hasPrevBtnTarget) {
      this.prevBtnTarget.disabled = this.currentIndex === 0
    }

    if (this.hasNextBtnTarget) {
      this.nextBtnTarget.disabled = this.currentIndex === this.totalSlides - 1
    }
  }

  startAutoplay() {
    this.stopAutoplay()
    this.autoplayInterval = setInterval(() => {
      if (this.currentIndex < this.totalSlides - 1) {
        this.next()
      } else {
        this.currentIndex = 0
        this.updateUI()
      }
    }, 8000) // 8 seconds per slide
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval)
      this.autoplayInterval = null
    }
  }
}
